import { send } from "@utils/fetch";
import saveToBraze from "@utils/brazeUploader";

export function getReferralCode() {
  return send("GET", `/api/referrals/v1/user_referral_code`);
}

export async function submitReferralEmails(
  referrerEmail: string,
  referredEmails: string[],
  source: "buyflow" | "share-page",
  withReferralCode = false,
  extraEventParams: Record<string, any> = {}
) {
  const eventParams: Record<string, any> = {
    source,
    referrer_email: referrerEmail,
    referral_emails: referredEmails,
  };

  if (withReferralCode) {
    const { referral_code } = await getReferralCode();
    eventParams.referral_link = `https://www.noom.com/r/${referral_code}`;
    eventParams.referral_code = referral_code;
  } else {
    eventParams.referral_link = `https://www.noom.com/referral?ref_email=${referrerEmail}`;
  }

  await saveToBraze({
    event: {
      event_name: "submittedReferralEmail",
      event_data: { ...eventParams, ...extraEventParams },
    },
  });
}
